import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Tooltip as ReactTooltip } from "react-tooltip";
import styled from "styled-components";
import { lighten } from "polished";

const ProgressBarWrapper = styled.div`
  display: flex;
  width: 100%;
  height: ${(props) => props.height}px;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${(props) =>
    props.theme.nightmode ? "#2e3844" : "#f2f3f8"};
  border-color: ${(props) => (props.theme.nightmode ? "#2e3844" : "#f2f3f8")};
  .progress {
    transition: width 2s ease-in-out;
    border: 1px solid
      ${(props) => (props.theme.nightmode ? props.theme.dark_blue : "white")} !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    border-radius: 0 !important;
    padding-left: 5px;
    &.bg-gravoc {
      background: ${(props) => props.theme.blue_g} !important;
      &:hover {
        background: ${(props) => lighten(0.03, props.theme.blue_g)};
      }
      p {
        color: #fff !important;
      }
    }
    &.success {
      background: ${(props) => props.theme.green_g} !important;
      &:hover {
        background: ${(props) => lighten(0.03, props.theme.green_g)};
      }
      p {
        color: #fff !important;
      }
    }
    &.warning {
      background: ${(props) => props.theme.gold_g} !important;
      &:hover {
        background: ${(props) => lighten(0.03, props.theme.gold_g)};
      }
    }
    &.danger {
      background: ${(props) => props.theme.red_g} !important;
      &:hover {
        background: ${(props) => lighten(0.03, props.theme.red_g)};
      }
      p {
        color: #fff !important;
      }
    }
    &:hover {
      opacity: 0.9;
    }
    p {
      font-family: "Nunito";
      text-transform: uppercase;
      font-size: 1.2rem;
    }
  }
`;

const ProgressBar = ({
  values,
  height,
  auth,
  projectConsumedWithoutCall,
  updatedDuration
}) => {
  const [bars, setBars] = useState([]);

  useEffect(() => {
    setBars(values);
  }, [values]);

  return (
    <>
      <ProgressBarWrapper
        height={height}
        id="timesheet-bar-tooltip"
        data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
      >
        {bars.map(({ classNames, percentage, callId }, index) => (
          <div
            key={`${callId}-${index}`}
            className={`animated slideInLeft progress ${classNames}`}
            style={{ width: `${percentage}%` }}
          />
        ))}
      </ProgressBarWrapper>
      <ReactTooltip
        anchorId="timesheet-bar-tooltip"
        className={`custom-tooltip ${auth.isNightMode ? "dark" : "light"}`}
        place="bottom"
        type="light"
        effect="solid"
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ marginBottom: 5, borderBottom: "1px solid #50accb" }}>
            Total Actual Hours:
            <span>
              {(projectConsumedWithoutCall + updatedDuration).toFixed(2)}
            </span>
          </p>
          <p
            style={{
              marginBottom: 5
            }}
          >
            This Call:<span>{updatedDuration.toFixed(2)}</span>
          </p>
          <p
            style={{
              marginBottom: 5
            }}
          >
            Other Calls:
            <span>{projectConsumedWithoutCall.toFixed(2)}</span>
          </p>
        </div>
      </ReactTooltip>
    </>
  );
};

ProgressBar.propTypes = {
  values: PropTypes.array,
  height: PropTypes.number,
  auth: PropTypes.object,
  projectConsumedWithoutCall: PropTypes.number,
  updatedDuration: PropTypes.number
};

ProgressBar.defaultProps = {
  height: 8
};

export default ProgressBar;
